import { render, staticRenderFns } from "./Briefcase.vue?vue&type=template&id=7c0116cd&scoped=true&"
import script from "./Briefcase.vue?vue&type=script&lang=js&"
export * from "./Briefcase.vue?vue&type=script&lang=js&"
import style0 from "./Briefcase.vue?vue&type=style&index=0&id=7c0116cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0116cd",
  null
  
)

export default component.exports